import { MSTGQLObject } from "mst-gql"

export const ModelBase = MSTGQLObject
